module.exports = __webpack_public_path__ + "static/media/allPayments.8fe00ab1.svg";